import r from"./lib/hash-to-uuid.js";const s=(s="")=>{const t=r.stringToCharBuffer(s),a=new Uint8Array(0),o=r.concatBuffers(a,t),h=r.sha1Hash(o);return r.hashToUuid(h,5)};export{s as default};
